/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_zoi__pois_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Unsere Empfehlungen für Unterkünfte, Restaurants...`
};

const en_zoi__pois_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Our recommendations for accommodation, restaurants...`
};

const es_zoi__pois_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Nuestras recomendaciones de alojamiento, restaurantes...`
};

const fr_zoi__pois_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Nos recommandations d’hébergements, de restaurants...`
};

const it_zoi__pois_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `I nostri consigli per alloggi, ristoranti...`
};

const nl_zoi__pois_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Onze aanbevelingen voor accommodatie, restaurants...`
};

const pt_zoi__pois_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Nossas recomendações de hospedagem, restaurantes...`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const zoi__pois_subtitle = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.zoi__pois_subtitle(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("zoi__pois_subtitle", locale)
	if (locale === "de") return de_zoi__pois_subtitle(inputs)
	if (locale === "en") return en_zoi__pois_subtitle(inputs)
	if (locale === "es") return es_zoi__pois_subtitle(inputs)
	if (locale === "fr") return fr_zoi__pois_subtitle(inputs)
	if (locale === "it") return it_zoi__pois_subtitle(inputs)
	if (locale === "nl") return nl_zoi__pois_subtitle(inputs)
	return pt_zoi__pois_subtitle(inputs)
};